<template>
    <form>
        <form-alert />

        <div class="form-group">
            <label for="name">
                {{ $t("enquiries.name") }}
            </label>

            <form-input
                v-model="mutableData.name"
                v-validate="{
                  required: true,
                }"
                name="name"
                :data-vv-as="$t('enquiries.name')"
            >
            </form-input>
        </div>

        <div class="form-group">
            <label for="email">
                {{ $t("enquiries.email") }}
            </label>

            <form-input
                v-model="mutableData.email"
                v-validate="{
                  required: true,
                  email: true,
                }"
                name="email"
                :data-vv-as="$t('enquiries.email')"
            >
            </form-input>
        </div>

        <div class="form-group">
            <label for="message">
                {{ $t("enquiries.message") }}
            </label>

            <form-textarea
                v-model="mutableData.message"
                v-validate="{
                  required: true,
                }"
                name="message"
                rows="5"
                :data-vv-as="$t('enquiries.message')"
            />
        </div>

        <button
            :disabled="isSending || isSuccess"
            class="btn btn-success btn-block"
            @click.prevent="submitForm()"
        >
            {{ $t("enquiries.submit") }}
        </button>
    </form>
</template>

<script>
import Form from '../mixins/Form.js';

export default {
    mixins: [
        Form,
    ],
};
</script>
